import { Component, h, tag } from "omi";

import { NWGraphic } from "@/components/atoms/nw-graphic";
import { storageSignal } from "@/utils/signals/storageSignal";
import { NWBadge, NWBanner, NWButton, NWTooltip } from "@/components";
import { tailwind } from "@/tailwind";

import { AvatarSection } from "../../ui/header/avatarSection";
import { GradientBackground } from "../../ui/gradientBackground";

@tag("pages-portfolio-features-teaser")
export class PortfolioTeaser extends Component {
  static css = [tailwind];

  private hasRatedFeature = storageSignal("portfolio-fr", { default: false });

  private handleFeatureRating = (rating: "love" | "like" | "dislike") => {
    this.hasRatedFeature.value = true;

    import("@/services/analyticsService").then(({ useAnalyticsService }) => {
      useAnalyticsService().trackPortfolioFeatureRating(rating);
    });
  };

  private renderFeatureRating = () => {
    if (this.hasRatedFeature.value) {
      return (
        <NWBanner className="animate-fadeInFast h-12 text-sm" type="success">
          Thanks for letting us know!
        </NWBanner>
      );
    }

    return (
      <div className="flex items-center gap-4 mx-auto w-fit">
        <NWTooltip placement="top" content="Love it!">
          <NWButton size="icon" type="icon" onClick={() => this.handleFeatureRating("love")}>
            <span className="text-2xl">❤️</span>
          </NWButton>
        </NWTooltip>
        <NWTooltip placement="top" content="I like this">
          <NWButton size="icon" type="icon" onClick={() => this.handleFeatureRating("like")}>
            <span className="text-2xl">👍</span>
          </NWButton>
        </NWTooltip>
        <NWTooltip placement="top" content="Not a fan">
          <NWButton size="icon" type="icon" onClick={() => this.handleFeatureRating("dislike")}>
            <span className="text-2xl">👎</span>
          </NWButton>
        </NWTooltip>
      </div>
    );
  };

  render() {
    return (
      <div className="flex-1 h-screen z-0 w-full flex flex-col items-center bg-white justify-around">
        <AvatarSection />
        <div
          id="portfolio-container"
          className="relative max-w-screen-md overflow-hidden w-4/5 lg:w-3/5 mx-auto h-96 flex items-center flex-row"
        >
          <div className="w-1/2 hidden relative flex-1 h-full rounded-l-[64px] md:flex md:items-center md:justify-center overflow-hidden">
            <NWGraphic mode="static" name="omg-bubble" className="z-10 text-white" />
            <GradientBackground />
          </div>
          <div className="md:w-1/2 rounded-[64px] md:rounded-none md:rounded-r-[64px] flex items-center justify-center flex-col h-full py-16 px-10 text-center space-y-4 border-y border md:border-r border-gray-300">
            <div class="w-fit mx-auto">
              <NWBadge withIndicator padding="xs">
                <span className="normal-case text-secondary">Coming soon</span>
              </NWBadge>
            </div>
            <h1 className="text-4xl font-bold">Project Portfolio</h1>
            <p className="text-normal text-secondary">
              Surprise! We're building a home for your projects. What do you think?
            </p>

            {this.renderFeatureRating()}
          </div>
        </div>
        <div></div>
      </div>
    );
  }
}
